import React from "react";
import { Link } from "react-router-dom";

const HeroBanner = () => {
  return (
    <>
      {/*===== HERO AREA STARTS =======*/}
      <div
        className="hero5-section-area"
        style={{
          backgroundImage: "url(assets/img/bg/header-bg5.png)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="header-content-area heading9">
                <h5>
                  <img src="assets/img/icons/logo-icons5.svg" alt="" />
                  India's Trusted PAN Card &amp; Digital Service Provider
                </h5>
                <h2 className="text-anime-style-2 text-white">
                  PAN Card, Insurace, Recharges, Bill Payments &amp; API
                  Solutions – All in One Place
                </h2>
                <p
                  data-aos="fade-left"
                  data-aos-duration={1000}
                  className="pt-2"
                >
                  Panmitra Online Service Pvt. Ltd. is a trusted name in digital
                  & financial services since 2020. We specialize in PAN card
                  processing and seamless utility payments, empowering
                  businesses with cutting-edge technology.
                </p>
                <div
                  className="btn-area1"
                  data-aos="fade-left"
                  data-aos-duration={1200}
                >
                  <a href="/contact-us" className="header-btn9">
                    Get Started <i className="fa-solid fa-arrow-right" />
                  </a>
                  {/* <Link to="/become-partner" className="header-btn10">
                    Become a Partner <i className="fa-solid fa-arrow-right" />
                  </Link> */}
                </div>
              </div>
            </div>
            <div className="col-lg-6 pb-5">
              <div className="hero-images-area">
                <div className="imges">
                  <img
                    src="images/hero-banner-1.png"
                    alt="Panmitra Services"
                    data-aos="zoom-in"
                    data-aos-duration={1000}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*===== HERO AREA ENDS =======*/}
    </>
  );
};

export default HeroBanner;
